<div class="h-full w-full">
    <div class="flex justify-center items-center h-screen">
      <div class="rounded-2xl bg-[#fff] h-full w-full mx-3"
           style="background-image: url('/src/assets/images/emblembg.png'); background-repeat: no-repeat; background-position: center; background-size: 33%">
        <div class="my-4">
          <!-- BEGIN: Page button -->
          <app-page-title title="Approval flow details" [useBackButton]="true"></app-page-title>
          <!-- END: Page button -->
        </div>

        <div class="grid grid-cols-12 p-3 bg-gray-50 " *ngIf="selectedApprovalFlow$ | async as selectedApprovalFlow">
          <tgsd-view-details-item class="col-span-12 md:col-span-8"
                                  key="Approval Flow Title"
                                  [value]="selectedApprovalFlow?.flowTitle">
          </tgsd-view-details-item>
          <tgsd-view-details-item class="col-span-12 md:col-span-4"
                                  key="Flow Process"
                                  [value]="selectedApprovalFlow?.flowProcess?.replaceAll('_', ' ')">
          </tgsd-view-details-item>
        </div>


        <div class="container-fluid">
          <div class="row h-20 rounded-lg flex items-center">
            <div class="col">
              <div class="flex justify-between items-center">
                <span class="font-medium">Approval Flow Stages</span>
                <button  mat-raised-button  class="add-button"
                        (click)="addEditStagesFlow()"   *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">
                    <mat-icon svgIcon="add"></mat-icon>
                    <span class="mx-1">Add Stage</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- BEGIN: User table -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-8 flex flex-col gap-3">

              @for (stage of tableData$ | async; track stage) {
                <div class="bg-gray-100 rounded-xl p-3 grid grid-cols-12 gap-2">
                  <tgsd-view-details-item class="col-span-12 md:col-span-8"
                                          key="Stage Name"
                                          [value]="stage?.stageName">
                  </tgsd-view-details-item>
                  <tgsd-view-details-item class="col-span-12 md:col-span-4"
                                          key="Designation"
                                          valueType="translate"
                                          [value]="stage?.stageDesignation?.designationName">
                  </tgsd-view-details-item>

                  <div class="col-span-12 flex flex-wrap justify-between gap-2 text-xs">
                    <div class="flex items-center flex-wrap gap-3">
                      <div>
                        @if (stage?.stageIsStarting) {
                          <span class="px-2 border-[1px] rounded-full border-green-500 text-green-500">Starting</span>
                        } @else {
                          <span class="px-2 border-[1px] rounded-full border-gray-400 text-gray-400">Not Starting</span>
                        }
                      </div>

                      <div>
                        @if (stage?.stageIsEnding) {
                          <span class="px-2 border-[1px] rounded-full border-red-500 text-red-500">Ending</span>
                        } @else {
                          <span class="px-2 border-[1px] rounded-full border-gray-400 text-gray-400">Not Ending</span>
                        }
                      </div>

                      @if (stage?.successorStage?.stageName) {
                        <div class="rounded-full flex bg-white">
                          <div class="rounded-full p-1 px-2 bg-primary text-white">
                            Successor
                          </div>
                          <div class="p-0.5 px-2 flex gap-1 items-center">
                            {{ stage?.successorStage?.stageName }}

                            <div
                              (click)="deleteApprovalSuccessor(stage)"
                              class="px-1 py-0.5 cursor-pointer hover:bg-red-100 hover:text-red-600 bg-red-50 text-red-500 rounded-full">
                              <app-font-awesome-icon iconName="close"></app-font-awesome-icon>
                            </div>
                          </div>
                        </div>
                      }
                    </div>


                    <div class="flex gap-2 flex-wrap" *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">
                      @if (!stage.stageIsEnding) {
                        <button (click)="addSuccessor(stage)" mat-raised-button class="" color="primary">
                          <mat-icon>add</mat-icon>
                          @if(stage?.successorStage?.stageName){ Update } @else { Set } Successor
                        </button>
                      }
                      <button (click)="addEditStagesFlow(stage)" mat-button class="!bg-white">
                        <mat-icon>edit</mat-icon>
                        Edit
                      </button>
                      <button (click)="deleteApprovalFlowStages(stage)" mat-button class="!bg-white !text-red-400">
                        <mat-icon>delete</mat-icon>
                        Delete
                      </button>
                    </div>

                  </div>
                </div>
              }


<!--                <app-data-table-hybrid [columnHeader]="tableColumns" [tableData]="tableData$" [isPageable]="true">-->

<!--                  <ng-template #actions let-data="data">-->
<!--                    &lt;!&ndash; BEGIN: Table actions &ndash;&gt;-->
<!--                    <div class="action-icons">-->
<!--                      <div>-->
<!--                        <span class="icon-holder" matTooltip="Edit" matTooltipPosition="left"-->
<!--                            (click)="addEditStagesFlow(data)" *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">-->
<!--                                              <mat-icon svgIcon="edit"></mat-icon>-->
<!--                      </span>-->
<!--                      </div>-->
<!--                      &lt;!&ndash; END: Edit &ndash;&gt;-->
<!--                       &lt;!&ndash; BEGIN: Delete category &ndash;&gt;-->
<!--                      <div *ngIf="data?.stageIsEnding === false">-->
<!--                        <span-->
<!--                        class="icon-holder !border-red-800"-->
<!--                        matTooltip="Delete Approval Flow Successor"-->
<!--                        matTooltipPosition="left"-->
<!--                        matTooltipClass="delete-tooltip"-->
<!--                        (click)="deleteApprovalSuccessor(data)"-->
<!--                        *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">-->
<!--                        <mat-icon-->
<!--                          svgIcon="delete"-->
<!--                          style="color: var(&#45;&#45;danger-color)"></mat-icon>-->
<!--                      </span>-->
<!--                      </div>-->
<!--                   &lt;!&ndash; END: Delete category &ndash;&gt;-->


<!--                      &lt;!&ndash; BEGIN: Delete category &ndash;&gt;-->
<!--                      <span class="icon-holder !border-red-800" matTooltip="Delete Approval Flow Stages" matTooltipPosition="left"-->
<!--                            matTooltipClass="delete-tooltip" (click)="deleteApprovalFlowStages(data)" *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">-->
<!--                                              <mat-icon svgIcon="delete" style="color: var(&#45;&#45;danger-color)"></mat-icon>-->
<!--                      </span>-->
<!--                      &lt;!&ndash; END: Delete category &ndash;&gt;-->
<!--                    </div>-->
<!--                    &lt;!&ndash; END: Table actions &ndash;&gt;-->
<!--                  </ng-template>-->
<!--                </app-data-table-hybrid>-->
            </div>

            <div class="col-md-4">
              <app-flow-chart (newConnection)="setStageSuccessor($event?.from, $event?.to)"></app-flow-chart>
            </div>
          </div>
        </div>
        <!-- END: User table -->
      </div>
    </div>
  </div>
